// removed by extract-text-webpack-plugin
module.exports = {"title":"pages-MyAccount-BidVerfiy-component-dot-info-title","form":"pages-MyAccount-BidVerfiy-component-dot-info-form"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/MyAccount/BidVerfiy/component/dot-info/index.css
// module id = 1792
// module chunks = 0